import request from './index'
import constant from './constant'

export function getConstant(key) {
	let language = sessionStorage.getItem("language") || 'HK';
	return constant[key][language];
}

export function getLanguageList(cb, fcb) {
	return request({
		url: '/platform-admin/website/api/dict/getDictItems/language',
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getConfigValue(paramKey, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/config/get/' + language,
		method: 'get',
		params: {
			paramKey: paramKey + '_' + language
		}
	}).then(res => {
		cb && cb(res.data.data);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getChannelList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/channel/list/' + language + '?type=' + params.type,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getBannerList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/banner/list/' + language + '?type=' + params.type,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getNewsList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/news/list/' + language + '?tags=' + params.tags,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.data);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getNewsInfo(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/news/info/' + language + '?id=' + params.id,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.data);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getUserExperienceList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/userexperience/list/' + language,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getUserExperienceInfo(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/userexperience/info/' + language + '?id=' + params.id,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.info);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getDevelopmentHistoryList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/developmenthistory/list/' + language,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getQuestionsAnswersList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/questionsanswers/list/' + language,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function addApplyInfo(data, cb, fcb) {
	data['source'] = sessionStorage.getItem("source-code") || '';
	return request({
		url: '/platform-admin/website/api/bookingApply/save',
		method: 'post',
		data
	}).then(res => {
		cb && cb(res.data.data);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getUserContrastList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/usercontrast/list/' + language,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}

export function getUserReflectionsList(params, cb, fcb) {
	let language = sessionStorage.getItem("language") || 'HK';
	return request({
		url: '/platform-admin/website/api/userreflections/list/' + language,
		method: 'get'
	}).then(res => {
		cb && cb(res.data.list);
	}).catch(err => {
		fcb && fcb();
	})
}


// WEBPACK FOOTER //
// ./src/api/api.js